module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body extratoff"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.cronograma),
      expression: "loading.cronograma"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(false) ? _c('b-button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.buscaCronograma($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atualizar")]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm._.includes(['ANALISE', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "col-md-6",
    attrs: {
      "title": '<h5>Veja os itens em cada atividade a que pertente ou agrupado por recursos da Fundação e Contrapartidas</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label col-md-5"
  }, [_vm._v("Layout agrupado por: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutExtrato),
      expression: "layoutExtrato"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.layoutExtrato = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "classico"
    }
  }, [_vm._v("Atividades")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "porOrigem"
    }
  }, [_vm._v("Origem do Recurso")])])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'filtroItens')) ? _c('div', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    class: !_vm._.includes(['ANALISE', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso) ? 'col-md-6' : 'col-md-12',
    attrs: {
      "title": '<h5>' + (_vm.layoutFiltrosSelecionados.length === 0 ? 'Mostrar o(s) item(ns) que contém o que for selecionado' : (_vm.layoutFiltrosSelecionados.length === 1 ? ('Somente mostrando os que tem ' + _vm.layoutFiltrosSelecionados[0]) : ('No cronograma filtrando os itens ao mesmo tempo por: ' + _vm._.join(_vm.layoutFiltrosSelecionados, ', ')))) + '<br/>Obs.: Filtros não alteram totais</h5>'
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3"
  }, [_vm._v("Mostrar item: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "saldos"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "saldos") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "saldos",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Com saldo "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "produtos"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "produtos") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "produtos",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Produtos "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "servicos"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "servicos") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "servicos",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Serviços "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "contrapartidas"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "contrapartidas") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "contrapartidas",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Contrapartidas "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totais.adiantavel.total.orcado !== 0),
      expression: "totais.adiantavel.total.orcado !== 0"
    }],
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "adiantaveis"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "adiantaveis") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "adiantaveis",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Adiantáveis "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm._.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], _vm.layoutSolicitacao) && _vm.totais.solicitacao.percentual !== 0) || _vm.alteracoes.length > 0 || _vm.inclusoes.length > 0 || !_vm.solicitacao),
      expression: "(_.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], layoutSolicitacao) && totais.solicitacao.percentual !== 0) || alteracoes.length > 0 || inclusoes.length > 0 || !solicitacao"
    }],
    staticClass: "checkbox-inline"
  }, [_c('label', {
    staticClass: "checkbox-inline new-control new-control-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.layoutFiltrosSelecionados),
      expression: "layoutFiltrosSelecionados"
    }],
    attrs: {
      "type": "checkbox",
      "value": "solicitados"
    },
    domProps: {
      "checked": Array.isArray(_vm.layoutFiltrosSelecionados) ? _vm._i(_vm.layoutFiltrosSelecionados, "solicitados") > -1 : (_vm.layoutFiltrosSelecionados)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.layoutFiltrosSelecionados,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "solicitados",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.layoutFiltrosSelecionados = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.layoutFiltrosSelecionados = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.layoutFiltrosSelecionados = $$c
        }
      }
    }
  }), _vm._v(" Solicitado "), _c('div', {
    staticClass: "new-control-indicator"
  })])])])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.etapaProcesso != 'VISUALIZACAO' && _vm.formEditavel && !_vm._.isNull(_vm.layoutSolicitacao)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.irAtividades
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Nova Atividade")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [(_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('thead', [_c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "2",
      "title": '<h5>Valor total contratado no projeto por Atividade e Item</h5>'
    }
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "colspan": "2",
      "title": '<h5>Saldo restante de cada Atividade e Item</h5>'
    }
  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
    staticClass: "centralizado"
  }, [_vm._v(" ")]) : _vm._e()]), _vm._v(" "), _c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s((_vm.layoutExtrato === 'porOrigem' ? 'Origem do Recurso' : 'Atividade')) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Qtde")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
    }
  }, [_vm._v("Atingimento")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
    staticClass: "centralizado"
  }, [_vm._v(" ")]) : _vm._e()])]) : _c('thead', [_c('tr', {
    staticClass: "cabecalho"
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(_vm._s((_vm.layoutExtrato === 'porOrigem' ? 'Origem do Recurso' : 'Atividade')) + " / Recursos (itens do cronograma)")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Orçado")]), _vm._v(" "), _c('th', {
    staticClass: "centralizado"
  }, [_vm._v("Saldo")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "centralizado",
    attrs: {
      "title": '<h5>Percentual aproximado já liberado<br/>Não considera Economicidade</h5>'
    }
  }, [_vm._v("Atingimento")]), _vm._v(" "), (_vm.formEditavel) ? _c('th', {
    staticClass: "centralizado"
  }, [_vm._v(" ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l(((_vm.layoutExtrato === 'classico' ? [
    ['1', '2', '5']
  ] : (_vm.layoutExtrato === 'porOrigem') ? [
    ['1', '5'],
    ['2']
  ] : [
    []
  ])), function(origem) {
    return [(_vm.layoutExtrato === 'porOrigem') ? _c('tr', [_c('td', {
      staticClass: "atividade",
      attrs: {
        "colspan": "8"
      }
    }, [_vm._v(_vm._s((_vm._.includes(origem, '2')) ? 'Recursos de Contrapartida' : 'Recursos da Fundação BB'))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.propsAtividades), function(atividade, atividadeIndex) {
      return [(_vm.layoutExtrato === 'classico') ? _c('tr', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm._.get(_vm.processoSolicitacao, 'processo.situacao', 'EM_EXECUCAO') === 'EM_EXECUCAO' || (_vm._.includes(['FEITO', 'CANCELADO'], _vm.processoSolicitacao.processo.situacao) && _vm._.countBy(atividade.itens_orcamentos, 'mostrar')['true'])),
          expression: "_.get(processoSolicitacao, 'processo.situacao', 'EM_EXECUCAO') === 'EM_EXECUCAO' || (_.includes(['FEITO', 'CANCELADO'], processoSolicitacao.processo.situacao) && _.countBy(atividade.itens_orcamentos, 'mostrar')['true'])"
        }],
        staticClass: "atividade"
      }, [_c('td', {
        staticClass: "esquerda celula b1 b3 b4 nome_atividade",
        attrs: {
          "colspan": "2"
        }
      }, [_vm._v(_vm._s(atividade.ds_nome))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(_vm._s(_vm._f("decimal2")(atividade.valorOrcado)))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
        staticClass: "centralizado celula b1 b3 b4"
      }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3"
      }, [_vm._v(_vm._s(_vm._f("decimal2")(atividade.valorSaldo)))]), _vm._v(" "), _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [_vm._v(_vm._s(_vm._f("percentage")(atividade.percAtingimento)))]), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
        staticClass: "centralizado celula b1 b3 b2"
      }, [(_vm._.isEmpty(_vm.itemEditando) && !_vm._.isNull(_vm.layoutSolicitacao) && _vm.etapaProcesso !== 'VISUALIZACAO') ? _c('button', {
        staticClass: "btn btn-primary btn-sm btn-flat",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.adicionaItem(atividade, atividadeIndex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" Adicionar Novo Item")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((atividade.itens_orcamentos), function(item, itemIndex) {
        return (_vm._.includes(origem, ('' + item.origem).substring(0, 1))) ? [(!_vm._.has(item, 'mostrar') || item.mostrar) ? [_c('tr', {
          class: ('' + _vm.modoVisualizacaoAlteracoes) === 'DETALHADO' && _vm.ehItemNovo(item) ? 'modificacaoInclusao' : '',
          attrs: {
            "prefix": "activityItem",
            "suffix": "item.id",
            "row": "item"
          }
        }, [(_vm._.isEmpty(_vm.itemEditando) || (!_vm._.isEmpty(_vm.itemEditando) && _vm.itemEditando.item.id !== item.id)) ? [_c('td', {
          staticClass: "centralizado celula b3 b4"
        }, [(('' + item.origem).substring(0, 1) === '1') ? _c('span', [_vm._v("Fundação")]) : (('' + item.origem).substring(0, 1) === '2') ? _c('span', [_vm._v("Contrapartida")]) : (('' + item.origem).substring(0, 1) === '5') ? _c('span', [_vm._v("P.Estratégico")]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.alteracoes, function(a) {
          return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'adiantavel'
        })) ? _c('span', {
          staticClass: "alteracao"
        }, [_c('br'), _vm._v(" "), (_vm._.find(_vm.alteracoes, function(a) {
          return a.id === item.id && a.alteracao === 'adiantavel' && ('' + a.depois) === '1'
        })) ? _c('span', [_vm._v("Será adiantável")]) : _c('span', [_vm._v("Era adiantável")])]) : _c('span', {
          staticClass: "adiantavel"
        }, [(item.adiantavel === '1' || item.adiantavel === 1) ? _c('span', [_c('br'), _vm._v("Adiantável")]) : _vm._e()])]), _vm._v(" "), _c('td', {
          staticClass: "celula b3 b4"
        }, [(!_vm._.isNull(item.item)) ? _c('div', {
          staticClass: "item"
        }, [_c('div', {
          staticClass: "item_despesa esquerda",
          style: ((!_vm._.includes(_vm.itensLayout, 'quantidade')) ? 'width: 100%' : '')
        }, [_vm._v("(" + _vm._s(_vm._.upperFirst(_vm._.lowerCase(item.item.ds_type))) + ")  " + _vm._s(item.item.ds_code + ' / ' + item.item.ds_description))]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'contaFinanceira')) ? _c('div', {
          staticClass: "conta_financeira direita"
        }, [_vm._v(_vm._s(item.contaFinanceiraNumero) + " / " + _vm._s(item.contaFinanceiraDescricao))]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "observacao esquerda"
        }, [_c('span', {
          staticClass: "id_item"
        }, [_vm._v("#" + _vm._s(item.id) + " ")]), _vm._v(" "), (item.observacaoOriginal !== null) ? _c('div', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(item.observacaoOriginal.replace(item.observacaoNova, '<span class=\'alteracao\'>' + item.observacaoNova + '</span>'))
          }
        })]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          staticClass: "centralizado celula b3 b4",
          attrs: {
            "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
          }
        }, [_c('span', {
          class: (_vm._.find(_vm.alteracoes, function(a) {
            return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'quantidadeOrcado'
          }) ? 'alteracao' : '')
        }, [_vm._v(_vm._s(item.quantidadeOrcado))])]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3"
        }, [_c('span', {
          class: (_vm._.find(_vm.alteracoes, function(a) {
            return _vm.alteracoes.length > 0 && a.id === item.id && a.alteracao === 'valorOrcado'
          }) ? 'alteracao' : '')
        }, [_vm._v(_vm._s(_vm._f("decimal2")((_vm.ehItemNovo(item) && _vm._.get(item, 'valorAlteracao', 0) !== 0 ? item.valorAlteracao : item.valorOrcado))))])]), _vm._v(" "), (_vm._.includes(_vm.itensLayout, 'quantidade') && _vm._.includes(['VISUALIZACAO', 'SOLICITACAO', 'REVISAO'], _vm.etapaProcesso)) ? _c('td', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          staticClass: "centralizado celula b3 b4",
          attrs: {
            "title": '<h5>' + (!_vm._.has(item, 'unidade_medida') || _vm._.isNull(item.unidade_medida) ? 'Sem unid. de medida' : (item.unidade_medida === 'Outros' && _vm._.has(item, 'medida_outros') && !_vm._.isNull(item.medida_outros) ? ('Outros:<br/>' + item.medida_outros) : item.unidade_medida)) + '</h5>'
          }
        }, [_vm._v("\n                      " + _vm._s(item.quantidadeSaldo) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3"
        }, [_vm._v("\n                      " + _vm._s(_vm._f("decimal2")((_vm.ehItemNovo(item) && _vm._.get(item, 'valorAlteracao', 0) !== 0 ? item.valorAlteracao : item.valorSaldo))) + "\n                      "), (_vm._.get(item, 'valorAlteracao', 0) !== 0) ? _c('span', [_c('br'), _vm._v(" "), _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          attrs: {
            "title": '<h5>' + item.justificativa + '</h5>'
          }
        }, [_c('span', {
          class: 'valor_alterado' + (_vm.layoutSolicitacao === 'SUPLEMENTACAO' && item.valorAlteracao < 0 ? ' label-danger' : '') + (item.valorAlteracao > 0 ? ' acrescimo_valor' : (item.valorAlteracao < 0 ? ' diminuicao_valor' : ''))
        }, [_c('i', {
          class: (item.valorAlteracao > 0 ? 'fa fa-plus-circle' : (item.valorAlteracao < 0 ? 'fa fa-minus-circle' : ''))
        }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(item.valorAlteracao))) + "\n                        ")])])]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "centralizado celula b3 b2"
        }, [(_vm.ehItemNovo(item)) ? _c('span', {
          staticClass: "label label-info"
        }, [_vm._v("Novo")]) : _c('span', [_vm._v("\n                      " + _vm._s(_vm._f("percentage")(item.percAtingimento)) + "\n                      "), (('' + item.economicidade) === '1') ? _c('i', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "fa fa-dollar economicidade",
          attrs: {
            "title": '<h5>Comprovado com Economicidade</h5>'
          }
        }) : _vm._e()])]), _vm._v(" "), (_vm.etapaProcesso === 'VISUALIZACAO') ? _c('td', {
          staticClass: "centralizado celula b3 b2"
        }, [(!_vm._.isNull(item.fk_cotacao)) ? _c('div', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          attrs: {
            "title": "Abrir Cotação"
          }
        }, [_c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          on: {
            "click": function($event) {
              return _vm.consultarAbrirCotacao(item.fk_cotacao)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-dollar",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1) : _c('div', [_vm._v(" - ")])]) : _vm._e(), _vm._v(" "), (_vm.formEditavel) ? _c('td', {
          staticClass: "celula b2 b3"
        }, [(_vm._.isEmpty(_vm.itemEditando)) ? _c('div', {
          staticClass: "centralizado"
        }, [(_vm.formEditavel && !_vm._.isNull(_vm.layoutSolicitacao)) ? _c('b-button', {
          staticClass: "btn btn-primary btn-sm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.editar(item, itemIndex, atividade, atividadeIndex)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Editar")]) : _vm._e()], 1) : _vm._e()]) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (_vm._.includes(['inserindo', 'editando'], _vm.itemEditando.acao) && !_vm._.has(_vm.listaSolicitacoes, 'processos') && _vm.itemEditando.itemIndex === itemIndex && _vm.itemEditando.atividadeIndex === atividadeIndex) ? _c('tr', [(!_vm._.isEmpty(_vm.itemEditando) && _vm.itemEditando.item.id === item.id) ? [_c('td', {
          staticStyle: {
            "padding": "0"
          },
          attrs: {
            "colspan": _vm.formEditavel ? 8 : 7
          }
        }, [_c('div', {
          staticClass: "quadroEdicaoItem"
        }, [_c('div', {
          staticClass: "form-horizontal"
        }, [_c('div', {
          staticClass: "form-group"
        }, [(_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('origem')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Origem:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-4"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.origem),
            expression: "itemEditando.item.origem"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "origem",
            "aria-label": "origem"
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(_vm.itemEditando.item, "origem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, function($event) {
              return _vm.zeraAdiantamento()
            }]
          }
        }, [_c('option', {
          attrs: {
            "value": "1"
          }
        }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "2"
          }
        }, [_vm._v("Contrapartida")]), _vm._v(" "), (_vm.totais.projeto.parceiros.orcado !== 0) ? _c('option', {
          attrs: {
            "value": "5"
          }
        }, [_vm._v("P.Estratégico")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('origem')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('origem')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('inicio')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Início:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-1"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.periodo_inicial),
            expression: "itemEditando.item.periodo_inicial"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          ref: "periodo_inicial",
          refInFor: true,
          staticClass: "form-control text-right",
          attrs: {
            "type": "number",
            "name": "inicio",
            "maxlength": "2",
            "aria-label": "Inicio do período",
            "min": atividade.inicio,
            "max": atividade.termino
          },
          domProps: {
            "value": (_vm.itemEditando.item.periodo_inicial)
          },
          on: {
            "change": _vm.validaPeriodo,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "periodo_inicial", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('inicio')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('inicio')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
          staticClass: "required-field"
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Fim:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-1"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.periodo_final),
            expression: "itemEditando.item.periodo_final"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          ref: "periodo_final",
          refInFor: true,
          staticClass: "form-control text-right",
          attrs: {
            "type": "number",
            "name": "fim",
            "maxlength": "2",
            "aria-label": "Fim do período",
            "min": atividade.inicio,
            "max": atividade.termino
          },
          domProps: {
            "value": (_vm.itemEditando.item.periodo_final)
          },
          on: {
            "change": _vm.validaPeriodo,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "periodo_final", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('fim')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('fim')))]) : _vm._e()])])]), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
          staticClass: "form-group"
        }, [_c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('item')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Item de despesa:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('multiselect', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          attrs: {
            "name": "item",
            "custom-label": function (ref) {
              var ds_code = ref.ds_code;
              var ds_description = ref.ds_description;

              return (ds_code + " / " + ds_description)
            },
            "searchable": true,
            "options": _vm.items,
            "close-on-select": true,
            "hide-selected": true,
            "preserve-search": false,
            "placeholder": "Escolha um item",
            "disabled": _vm.itemEditando.item.origem === null,
            "label": "ds_description",
            "track-by": "ds_code",
            "preselect-first": false
          },
          on: {
            "select": function($event) {
              return _vm.buscaContasFinanceiras($event)
            }
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(props) {
              return [_c('div', {
                staticClass: "option__desc"
              }, [_c('span', {
                staticClass: "option__title"
              }, [_vm._v(_vm._s(props.option.ds_code) + " / " + _vm._s(props.option.ds_description))])])]
            }
          }], null, true),
          model: {
            value: (_vm.itemEditando.item.item),
            callback: function($$v) {
              _vm.$set(_vm.itemEditando.item, "item", $$v)
            },
            expression: "itemEditando.item.item"
          }
        }, [_vm._v(" "), _c('span', {
          attrs: {
            "slot": "noResult"
          },
          slot: "noResult"
        }, [_c('font', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('item')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('item')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group"
        }, [(_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('span', [_c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('descrição item')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Descrição do item:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.observacaoOriginal),
            expression: "itemEditando.item.observacaoOriginal"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "name": "descrição item",
            "maxlength": "255"
          },
          domProps: {
            "value": (_vm.itemEditando.item.observacaoOriginal)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "observacaoOriginal", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('descrição item')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('descrição item')))]) : _vm._e()])])]) : (_vm.etapaProcesso !== 'VISUALIZACAO') ? _c('span', [_c('div', [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Descrição do item:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('span', {
          staticStyle: {
            "font-weight": "normal"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.itemEditando.item.observacaoOriginal)
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item['observacaoNova']),
            expression: "itemEditando.item['observacaoNova']"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "name": "descrição item",
            "maxlength": "255"
          },
          domProps: {
            "value": (_vm.itemEditando.item['observacaoNova'])
          },
          on: {
            "keyup": _vm.atualizaComponente,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, 'observacaoNova', $event.target.value)
            }
          }
        })])])]) : _vm._e()]), _vm._v(" "), (_vm.ehFBB || _vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
          staticClass: "form-group"
        }, [(_vm.ehItemNovo(_vm.itemEditando.item) || _vm.etapaProcesso === 'VISUALIZACAO') ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('quantidade')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Quantidade:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-1"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.quantidadeOrcado),
            expression: "itemEditando.item.quantidadeOrcado"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required|min_value:' + (_vm.ehItemNovo(_vm.itemEditando.item) ? 0 : _vm._.get(_vm.itemEditando, 'item.quantidadeMinima', 0))),
            expression: "'required|min_value:' + (ehItemNovo(itemEditando.item) ? 0 : _.get(itemEditando, 'item.quantidadeMinima', 0))"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "type": "number",
            "name": "quantidade",
            "min": "1",
            "maxlength": "6"
          },
          domProps: {
            "value": (_vm.itemEditando.item.quantidadeOrcado)
          },
          on: {
            "change": function($event) {
              return _vm.$forceUpdate()
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "quantidadeOrcado", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('quantidade')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v("Deve ser maior que " + _vm._s(_vm._.get(_vm.itemEditando, 'item.quantidadeMinima', 0)))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item) || _vm.etapaProcesso === 'VISUALIZACAO') ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('unidade de medida')
          }
        }, [_c('div', {
          staticClass: "col-sm-2"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.unidade_medida),
            expression: "itemEditando.item.unidade_medida"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }, {
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "unidade de medida",
            "title": '<h5>Unidade de medida</h5>'
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(_vm.itemEditando.item, "unidade_medida", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, _vm.atualizaComponente]
          }
        }, _vm._l((_vm.medidas), function(unidade_medida) {
          return _c('option', {
            domProps: {
              "value": unidade_medida
            }
          }, [_vm._v(_vm._s(unidade_medida))])
        }), 0), _vm._v(" "), (_vm.errors.first('unidade de medida')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('unidade de medida')))]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-3"
        }, [(_vm.itemEditando.item.unidade_medida === 'Outros') ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('medida outros')
          }
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.medida_outros),
            expression: "itemEditando.item.medida_outros"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }, {
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
          }],
          staticClass: "form-control text-right",
          attrs: {
            "type": "text",
            "name": "medida outros",
            "maxlength": "255",
            "aria-label": "Outros",
            "title": '<h5>Qual essa outra unidade de medida?</h5>'
          },
          domProps: {
            "value": (_vm.itemEditando.item.medida_outros)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "medida_outros", $event.target.value)
            }
          }
        }), _vm._v(" "), (_vm.errors.first('medida outros')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('medida outros')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('valor unitário')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Valor Unitário:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-2"
        }, [_c('money', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required|min_value:1'),
            expression: "'required|min_value:1'"
          }, {
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          staticClass: "form-control",
          attrs: {
            "name": "valor unitário",
            "title": '<h5>Valor unitário do item de despesa de acordo com orçamentos</h5>'
          },
          nativeOn: {
            "change": function($event) {
              return _vm.$forceUpdate()
            }
          },
          model: {
            value: (_vm.itemEditando.item.valor_unitario),
            callback: function($$v) {
              _vm.$set(_vm.itemEditando.item, "valor_unitario", $$v)
            },
            expression: "itemEditando.item.valor_unitario"
          }
        }), _vm._v(" "), (_vm.errors.first('valor unitário')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" Deve ser maior que R$ 1,00")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.etapaProcesso !== 'VISUALIZACAO') ? _c('div', {
          staticClass: "form-group"
        }, [(_vm.ehItemNovo(_vm.itemEditando.item)) ? _c('span', [_c('label', {
          staticClass: "control-label col-sm-offset-8 col-sm-2"
        }, [_vm._v("Valor Total:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-2"
        }, [_c('div', {
          staticStyle: {
            "padding": "6px 0"
          }
        }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")((_vm._.toNumber(_vm.itemEditando.item.valor_unitario) * _vm._.toNumber(_vm.itemEditando.item.quantidadeOrcado)))) + "\n                                ")])])]) : _c('span', [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Saldo Atual:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-1 col-lg-2"
        }, [_c('div', {
          staticStyle: {
            "padding": "6px 0"
          }
        }, [_vm._v(_vm._s(_vm._f("real")(_vm.itemEditando.item.valorSaldo)))])]), _vm._v(" "), _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('valor alterado')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v(_vm._s(_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Remanejamento' : 'Suplementação') + ":")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-4 col-lg-3"
        }, [_c('div', {
          staticClass: "input-group"
        }, [(_vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
          staticClass: "input-group-btn sinalValorAlterado"
        }, [_c('button', {
          staticClass: "btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.itemEditando.item.valorAlteracao = Math.abs(_vm.itemEditando.item.valorAlteracao);
              _vm.$forceUpdate()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle",
          style: ((_vm.itemEditando.item.valorAlteracao > 0 ? 'color: var(--cor-sucesso)' : ''))
        })]), _vm._v(" "), _c('button', {
          staticClass: "btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.itemEditando.item.valorAlteracao = Math.abs(_vm.itemEditando.item.valorAlteracao) * -1;
              _vm.$forceUpdate()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-minus-circle",
          style: ((_vm.itemEditando.item.valorAlteracao < 0 ? 'color: var(--cor-atencao)' : ''))
        })])]) : _vm._e(), _vm._v(" "), _c('money', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required|min_value:' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? (_vm._.toNumber(_vm.itemEditando.item.valorSaldo) * -1) : (_vm.layoutSolicitacao === 'SUPLEMENTACAO' ? 0.01 : 0))),
            expression: "'required|min_value:' + (layoutSolicitacao === 'REMANEJAMENTO' ? (_.toNumber(itemEditando.item.valorSaldo) * -1) : (layoutSolicitacao === 'SUPLEMENTACAO' ? 0.01 : 0))"
          }, {
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
          }],
          staticClass: "form-control",
          style: ('color:' + (_vm.itemEditando.item.valorAlteracao > 0 ? 'var(--cor-verde)' : (_vm.itemEditando.item.valorAlteracao < 0 ? 'var(--cor-vermelha)' : ''))),
          attrs: {
            "name": "valor alterado",
            "title": '<h5>' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Valor que será remanejado, informe valor positivo ou negativo diferente de zero.<br/>Exemplos: 580,00  ou  -346,20.</br>Para alterar apenas a descrição do item deixe o valor igual a R$ 0,00.' : 'Valor que será suplementado, informe valor positivo maior que zero.<br/>Exemplos: 620,00') + '</h5>'
          },
          nativeOn: {
            "change": function($event) {
              return _vm.atualizaComponente($event)
            }
          },
          model: {
            value: (_vm.itemEditando.item.valorAlteracao),
            callback: function($$v) {
              _vm.$set(_vm.itemEditando.item, "valorAlteracao", $$v)
            },
            expression: "itemEditando.item.valorAlteracao"
          }
        })], 1), _vm._v(" "), (_vm.errors.first('valor alterado')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'Remanejamentos, o item não pode ser 0,00 nem menor que ' + (_vm._.toNumber(_vm.itemEditando.item.valorSaldo) * -1) : 'Suplementação, o item não pode ser 0,00 nem negativo. Cancele ou desfaça alteração deste item'))]) : _vm._e()])]), _vm._v(" "), _c('label', {
          staticClass: "control-label col-sm-1 col-lg-1"
        }, [_vm._v("Saldo final:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-2"
        }, [_c('div', {
          staticStyle: {
            "padding": "6px 0"
          }
        }, [_vm._v("\n                                  " + _vm._s(_vm._f("real")((_vm._.toNumber(_vm.itemEditando.item.valorSaldo) + _vm._.toNumber(_vm.itemEditando.item.valorAlteracao)))) + "\n                                ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group"
        }, [(_vm._.includes(['SOLICITACAO', 'REVISAO', 'ANALISE', 'AUTORIZACAO'], _vm.etapaProcesso)) ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('adiantavel')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Adiantável:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-2"
        }, [_c('select', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.adiantavel),
            expression: "itemEditando.item.adiantavel"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "disabled": _vm.itemEditando.item.origem === '2' || _vm.itemEditando.item.origem === 2,
            "name": "adiantavel"
          },
          on: {
            "change": [function($event) {
              var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                return o.selected
              }).map(function(o) {
                var val = "_value" in o ? o._value : o.value;
                return val
              });
              _vm.$set(_vm.itemEditando.item, "adiantavel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
            }, _vm.atualizaComponente]
          }
        }, [_c('option', {
          attrs: {
            "value": "0"
          }
        }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
          attrs: {
            "value": "1"
          }
        }, [_vm._v("Sim")])]), _vm._v(" "), (_vm.errors.first('adiantavel')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('adiantavel')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['ANALISE', 'AUTORIZACAO'], _vm.etapaProcesso)) ? _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('conta financeira')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Conta Financeira:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-6"
        }, [_c('multiselect', {
          directives: [{
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          attrs: {
            "disabled": true,
            "name": "conta financeira",
            "custom-label": _vm.contaCodigo,
            "options": _vm.contasFinanceiras,
            "close-on-select": true,
            "hide-selected": true,
            "preserve-search": false,
            "placeholder": "Escolha um item",
            "label": "numero_conta",
            "track-by": "numero_conta",
            "preselect-first": false
          },
          on: {
            "select": _vm.selecionaConta
          },
          scopedSlots: _vm._u([{
            key: "option",
            fn: function(props) {
              return [_c('div', {
                staticClass: "option__desc"
              }, [_c('span', {
                staticClass: "option__title"
              }, [_vm._v(_vm._s(props.option.numero_conta) + " / " + _vm._s(props.option.descricao))])])]
            }
          }], null, true),
          model: {
            value: (_vm.itemEditando.item.conta_financeira),
            callback: function($$v) {
              _vm.$set(_vm.itemEditando.item, "conta_financeira", $$v)
            },
            expression: "itemEditando.item.conta_financeira"
          }
        }, [_vm._v(" "), _c('span', {
          attrs: {
            "slot": "noResult"
          },
          slot: "noResult"
        }, [_c('font', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("Nenhum registro localizado!")])], 1)]), _vm._v(" "), (_vm.errors.first('conta financeira')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('conta financeira')))]) : _vm._e()], 1)]) : _vm._e()]), _vm._v(" "), (_vm.etapaProcesso !== 'VISUALIZACAO') ? _c('div', {
          staticClass: "form-group"
        }, [(('' + _vm._.get(_vm.itemEditando, 'item.adiantavel', '')) === ('' + _vm._.get(_vm.propsAtividades, [_vm.itemEditando.atividadeIndex, 'itens_orcamentos', _vm.itemEditando.itemIndex, 'adiantavel'], '')) &&
          Math.abs(_vm._.toNumber(_vm._.get(_vm.itemEditando, ['item', 'valorAlteracao'], 0))) === 0 && (_vm._.get(_vm.itemEditando, ['item', 'observacaoNova'], '')).length === 0) ? _c('div', [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.justificativa),
            expression: "itemEditando.item.justificativa"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "name": "justificativa item",
            "maxlength": "400"
          },
          domProps: {
            "value": (_vm.itemEditando.item.justificativa)
          },
          on: {
            "keyup": _vm.atualizaComponente,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "justificativa", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s((_vm._.get(_vm.itemEditando, 'item.justificativa', '')).length) + " até 400 caracteres")])])]) : _c('div', {
          staticClass: "required-field",
          class: {
            'has-error': _vm.errors.first('justificativa item')
          }
        }, [_c('label', {
          staticClass: "control-label col-sm-2"
        }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
          staticClass: "col-sm-10"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item.justificativa),
            expression: "itemEditando.item.justificativa"
          }, {
            name: "validate",
            rawName: "v-validate",
            value: ('required'),
            expression: "'required'"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "name": "justificativa item",
            "maxlength": "400"
          },
          domProps: {
            "value": (_vm.itemEditando.item.justificativa)
          },
          on: {
            "keyup": _vm.atualizaComponente,
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.itemEditando.item, "justificativa", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('i', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s((_vm._.get(_vm.itemEditando, 'item.justificativa', '')).length) + " até 400 caracteres")]), _vm._v(" "), (_vm.errors.first('justificativa item')) ? _c('span', {
          staticClass: "label label-danger"
        }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa item')))]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "form-group"
        }, [_c('div', {
          staticClass: "col-sm-10 col-sm-offset-2"
        }, [_c('div', {
          staticClass: "col-md-4"
        }, [_c('button', {
          staticClass: "btn btn-confirm btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.ok()
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Ok")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-back btn-flat",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.cancelar(atividade)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Cancelar")])]), _vm._v(" "), _c('div', {
          staticClass: "col-md-4"
        }, [(_vm._.includes(_vm.itensLayout, 'substituicaoItem')) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.itemEditando.item['substituicao']),
            expression: "itemEditando.item['substituicao']"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": true,
            "checked": Array.isArray(_vm.itemEditando.item['substituicao']) ? _vm._i(_vm.itemEditando.item['substituicao'], true) > -1 : (_vm.itemEditando.item['substituicao'])
          },
          on: {
            "change": function($event) {
              var $$a = _vm.itemEditando.item['substituicao'],
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = true,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.itemEditando.item, 'substituicao', $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.itemEditando.item, 'substituicao', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.itemEditando.item, 'substituicao', $$c)
              }
            }
          }
        }), _vm._v(" Este item é substituição de algum outro?")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-md-4"
        }, [(_vm.ehItemNovo(_vm.itemEditando.item) && _vm.itemEditando.acao === 'editando') ? _c('button', {
          staticClass: "btn btn-danger btn-flat fr",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.itemEditando.acao = 'excluindo';
              _vm.cancelar(atividade)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir Item Novo")]) : _vm._e(), _vm._v(" "), (!_vm.ehItemNovo(_vm.itemEditando.item) && _vm._.find(_vm.alteracoes, ['id', _vm.itemEditando.item.id])) ? _c('button', {
          staticClass: "btn btn-primary btn-flat fr",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.desfazerAlteracao(_vm.itemEditando.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Desfazer Alterações")]) : _vm._e()])])])])])])] : _vm._e()], 2) : _vm._e()] : _vm._e()] : _vm._e()
      })]
    })]
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "animated fadeInDownOutUp modal-container"
  }, [(_vm.abrirCotacao && _vm.cotacaoForm.itemCotacao.length > 0) ? _c('cotacaoItens', {
    attrs: {
      "idProposta": _vm.proposta.id,
      "fk_cotacao": _vm.cotacaoForm.id,
      "cotacaoGravada": _vm.cotacaoForm.itemCotacao,
      "cotacaoManualGravada": _vm.cotacaoForm.itemCotacaoManual,
      "validandoCotacao": true,
      "visualizandoCotacao": true,
      "cotacaoValidada": _vm.cotacaoForm.itemCotacaoValidado,
      "toggleCotacao": _vm.toggleCotacao,
      "fecharValidacao": _vm.toggleCotacao
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(!_vm.loading.cronograma) ? _c('table', {
    class: 'totais ' + (_vm._.includes(['SUPLEMENTACAO', 'REMANEJAMENTO'], _vm._.get(_vm.solicitacao, 'nome', null)) ? 'solicitacao_total_' + (_vm.layoutSolicitacao === 'SUPLEMENTACAO' && _vm.totais.solicitacao.percentual > 0.25 ? 'atencao' : 'ok') : '')
  }, [_c('tr', [_c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', [_vm._v("Total Fundação")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', [_vm._v("Total Parceiro Estratégico")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', [_vm._v("Total Contrapartida")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.adiantavel.total.orcado !== 0) ? _c('span', [_vm._v("Total Adiantável")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [_vm._v("Total do Projeto")]), _vm._v(" "), _c('td', {
    staticClass: "centralizado"
  }, [(_vm.totais.solicitacao.fbb > 0 || _vm.totais.solicitacao.parceiros > 0 || _vm.totais.solicitacao.contrapartida > 0) ? _c('span', [_vm._v(_vm._s(_vm.layoutSolicitacao === 'SUPLEMENTACAO' ? 'Total da Suplementação' : 'Total do Remanejamento'))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos da Fundação</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos de Parceiro Estratégico</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado com recursos da Contrapartida</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantavel.total.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado para Adiantamento</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total.orcado)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    attrs: {
      "title": '<h5>Valor total orçado para este projeto</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.orcado)))])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 || _vm.inclusoes.length > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Total ' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'remanejado' : 'suplementado') + ' nesta solicitação</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida))))]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos da Fundação com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.fbb.saldo / _vm.totais.projeto.fbb.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.fbb.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos de Parceiro Estratégico com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.parceiros.saldo / _vm.totais.projeto.parceiros.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.parceiros.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida.orcado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos recursos da Contrapartida com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.contrapartida.saldo / _vm.totais.projeto.contrapartida.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.contrapartida.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantavel.total.orcado !== 0 && false) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo dos Adiantamento não solicitados ainda</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.adiantavel.total.saldo)))]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true }"
    }],
    staticClass: "saldo",
    attrs: {
      "title": '<h5>Saldo total do projeto com <span class=\'realce\'>' + (Math.round(100 - ((_vm.totais.projeto.total.saldo / _vm.totais.projeto.total.orcado) * 100)) | _vm.percent) + '%</span> de atingimento</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("real")(_vm.totais.projeto.total.saldo)))])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.percentual > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{ inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large' }"
    }],
    attrs: {
      "title": '<h5>Percentual ' + (_vm.layoutSolicitacao === 'REMANEJAMENTO' ? 'remanejado' : 'suplementado') + ' referente ao total orçado em recursos próprios</h5>'
    }
  }, [_vm._v("\n                " + _vm._s(_vm._f("percentage")(_vm.totais.solicitacao.percentual)))]) : _vm._e()])]), _vm._v(" "), (_vm._.get(_vm.solicitacao, 'nome', null) === 'SUPLEMENTACAO' && (_vm.totais.solicitacao.fbb !== 0 || _vm.totais.solicitacao.parceiros !== 0 || _vm.totais.solicitacao.contrapartida !== 0 || _vm.totais.solicitacao.total !== 0 || _vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0)) ? [_c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.fbb !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Fundação BB</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado ' + (_vm.totais.solicitacao.fbb > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.fbb < 0 ? 'diminuicao_valor' : ''))
  }, [_c('i', {
    class: (_vm.totais.solicitacao.fbb > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.fbb < 0 ? 'fa fa-minus-circle' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.fbb))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.parceiros !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Parceiros Estratégicos</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado ' + (_vm.totais.solicitacao.parceiros > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.parceiros < 0 ? 'diminuicao_valor' : ''))
  }, [_c('i', {
    class: (_vm.totais.solicitacao.parceiros > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.parceiros < 0 ? 'fa fa-minus-circle' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.parceiros))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.contrapartida !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' para Contrapartida</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado ' + (_vm.totais.solicitacao.contrapartida > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.contrapartida < 0 ? 'diminuicao_valor' : ''))
  }, [_c('i', {
    class: (_vm.totais.solicitacao.contrapartida > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.contrapartida < 0 ? 'fa fa-minus-circle' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.contrapartida))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.adiantavel > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' em itens Adiantáveis</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado ' + (_vm.totais.solicitacao.adiantavel > 0 ? 'acrescimo_valor' : (_vm.totais.solicitacao.adiantavel < 0 ? 'diminuicao_valor' : ''))
  }, [_c('i', {
    class: (_vm.totais.solicitacao.adiantavel > 0 ? 'fa fa-plus-circle' : (_vm.totais.solicitacao.adiantavel < 0 ? 'fa fa-minus-circle' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.solicitacao.adiantavel))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.layoutSolicitacao === 'SUPLEMENTACAO') ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de ' + _vm._.toLower(_vm.layoutSolicitacao) + ' neste projeto</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado ' + ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 ? 'acrescimo_valor' : ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) < 0 ? 'diminuicao_valor' : ''))
  }, [_c('i', {
    class: ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) > 0 ? 'fa fa-plus-circle' : ((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida) < 0 ? 'fa fa-minus-circle' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida))) + "\n                  ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  })]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "centralizado valor b1 atividade"
  }, [(_vm.totais.solicitacao.fbb !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total Fundação BB após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.fbb.orcado + _vm.totais.solicitacao.fbb))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor b1 atividade"
  }, [(_vm.totais.solicitacao.parceiros !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total em Parceiros Estratégicos após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.parceiros.orcado + _vm.totais.solicitacao.parceiros))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor b1 atividade"
  }, [(_vm.totais.solicitacao.contrapartida !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de Contrapartida após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.contrapartida.orcado + _vm.totais.solicitacao.contrapartida))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor b1 atividade"
  }, [(_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total de itens Adiantáveis após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.total.orcado + _vm.totais.adiantavel.total.alterado))) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor b1 atividade"
  }, [_c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": '<h5>Total do projeto após ' + _vm._.toLower(_vm.layoutSolicitacao) + '</h5>'
    }
  }, [_vm._v("\n                  " + _vm._s(_vm._f("real")((_vm.totais.solicitacao.fbb + _vm.totais.solicitacao.parceiros + _vm.totais.solicitacao.contrapartida + _vm.totais.projeto.total.orcado))) + "\n                ")])]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.solicitacao.percentual > 0.25) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Acima de 25%")]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.totais.projeto.fbb.alterado !== 0 || _vm.totais.projeto.parceiros.alterado !== 0 || _vm.totais.projeto.contrapartida.alterado !== 0 || _vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('tr', [_c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.fbb.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": (_vm.totais.projeto.fbb.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.fbb.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento' :
        (_vm.totais.projeto.fbb.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.fbb.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento' : ''))
    }
  }, [_c('span', {
    class: 'valor_alterado label-danger'
  }, [_c('i', {
    class: (_vm.totais.projeto.fbb.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.fbb.alterado < 0 ? 'fa fa-minus' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.fbb.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.parceiros.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": (_vm.totais.projeto.parceiros.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.parceiros.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento' :
        (_vm.totais.projeto.parceiros.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.parceiros.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento' : ''))
    }
  }, [_c('span', {
    class: 'valor_alterado label-danger'
  }, [_c('i', {
    class: (_vm.totais.projeto.parceiros.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.parceiros.alterado < 0 ? 'fa fa-minus' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.parceiros.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.projeto.contrapartida.alterado !== 0 && _vm.layoutSolicitacao === 'REMANEJAMENTO') ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": (_vm.totais.projeto.contrapartida.alterado > 0 ? '<h5>O total alterado esta com diferença positiva de <span class=\'realce\'>' + _vm.totais.projeto.contrapartida.alterado + '</span> e precisa ser ´zerado´ subtraindo este valor de um ou mais itens para permitir o remanejamento</h5>' :
        (_vm.totais.projeto.contrapartida.alterado < 0 ? '<h5>O total alterado esta com diferença de negativa de <span class=\'realce\'>' + _vm.totais.projeto.contrapartida.alterado + '</span> e precisa ser ´zerado´ acrescendo este valor em um ou mais itens ou criando itens novos para permitir o remanejamento</h5>' : ''))
    }
  }, [_c('span', {
    class: 'valor_alterado label-danger'
  }, [_c('i', {
    class: (_vm.totais.projeto.contrapartida.alterado > 0 ? 'fa fa-plus' : (_vm.totais.projeto.contrapartida.alterado < 0 ? 'fa fa-minus' : ''))
  }), _vm._v(" " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.projeto.contrapartida.alterado))) + "\n                ")])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }, [(_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "title": (_vm.totais.adiantavel.fbb.alterado !== 0 || _vm.totais.adiantavel.parceiros.alterado !== 0 ? '<h5>O total alterado nos Itens Adiantáveis esta com diferença. ' +
        (_vm.totais.adiantavel.fbb.alterado !== 0 ? '<br/>Nos recursos Fundação BB a diferença é de <span class=\'realce\'>' + _vm.totais.adiantavel.fbb.alterado + '</span> e precisa ser ´zerado´ ajustando o valor somente em <i>itens adiantáveis</i> nesse remanejamento' : '') +
        (_vm.totais.adiantavel.parceiros.alterado !== 0 ? '<br/>Nos recursos de Parc. Estratégico a diferença é de <span class=\'realce\'>' + _vm.totais.adiantavel.fbb.alterado + '</span> e precisa ser ´zerado´ ajustando o valor somente em <i>itens adiantáveis</i> nesse remanejamento' : '') : '') + '</h5>'
    }
  }, [_c('span', {
    class: 'valor_alterado label-danger'
  }, [(_vm.totais.adiantavel.fbb.alterado !== 0) ? _c('span', [_c('i', {
    class: (_vm.totais.adiantavel.fbb.alterado > 0 ? 'fa fa-plus' : (_vm.totais.adiantavel.fbb.alterado < 0 ? 'fa fa-minus' : ''))
  }), _vm._v("\n                    " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.fbb.alterado))) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.totais.adiantavel.fbb.alterado !== 0 && _vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', [_vm._v(" e ")]) : _vm._e(), _vm._v(" "), (_vm.totais.adiantavel.parceiros.alterado !== 0) ? _c('span', [_c('i', {
    class: (_vm.totais.adiantavel.parceiros.alterado > 0 ? 'fa fa-plus' : (_vm.totais.adiantavel.parceiros.alterado < 0 ? 'fa fa-minus' : ''))
  }), _vm._v("\n                    " + _vm._s(_vm._f("real")(Math.abs(_vm.totais.adiantavel.parceiros.alterado))) + "\n                  ")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  }), _vm._v(" "), _c('td', {
    staticClass: "centralizado valor"
  })]) : _vm._e()], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ed6c12c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/extrato.vue
// module id = 1857
// module chunks = 2